import isClient from 'commons/isClient';
import loadAffirmScript, {
  AFFIRM_LOAD_STRATEGY,
} from 'commons/loadAffirmScript';
import { observeDomConditionAsync } from 'commons/observeDomCondition';
import refreshFinancingContent from 'commons/refreshFinancingContent';

const AFFIRM_MODAL_LINK_TIMEOUT_MS = 100 * 100;

const getAffirmLink = affirmButtonRef =>
  affirmButtonRef?.current?.querySelector?.('a,button');

const ensureAffirmModalReady = async affirmButtonRef => {
  if (!isClient()) {
    throw new Error('Affirm modal is only available in the browser');
  }

  const existingLink = getAffirmLink(affirmButtonRef);
  if (existingLink) {
    return existingLink;
  }

  loadAffirmScript(
    () => {
      refreshFinancingContent();
    },
    { loadStrategy: AFFIRM_LOAD_STRATEGY.IMMEDIATE }
  );

  try {
    return await observeDomConditionAsync({
      getValue: () => getAffirmLink(affirmButtonRef),
      getTarget: () => affirmButtonRef?.current ?? document.body,
      timeout: AFFIRM_MODAL_LINK_TIMEOUT_MS,
    });
  } catch {
    throw new Error('Affirm modal link not ready in time');
  }
};

export default ensureAffirmModalReady;
